import { DateTime } from 'luxon'
import styled from 'styled-components'
import { Colors, Spacing } from '../../styles'
import Flex from '../atoms/Flex'
import GTButton from '../atoms/buttons/GTButton'
import { BodySmall, TitleSmall } from '../atoms/typography/Typography'
import { useOptionalCalendarPlan } from './CalendarPlanContext'

const Review = styled.div`
    padding: ${Spacing._8} ${Spacing._12};
    border-bottom: 1px solid ${Colors.background.border};
    background: ${Colors.background.panel};
`

const CalendarPlanReview = () => {
    const calendarPlan = useOptionalCalendarPlan()
    if (!calendarPlan) return null

    const {
        plan,
        isLoading,
        isReviewing,
        isConfirming,
        isClearing,
        hasPendingConfirmation,
        confirmationError,
        clear,
        reblock,
        confirm,
    } = calendarPlan
    if (!isReviewing) return null

    return (
        <Review data-testid="calendar-plan-review">
            <Flex column gap={Spacing._8}>
                <Flex justifyContent="space-between" alignItems="center" gap={Spacing._8}>
                    <Flex column>
                        <TitleSmall>Review today’s blocks</TitleSmall>
                        <BodySmall color="light">
                            {plan
                                ? `${DateTime.fromISO(plan.start).toFormat('h:mm a')}–${DateTime.fromISO(
                                      plan.end
                                  ).toFormat('h:mm a')}`
                                : 'Finding open time…'}
                        </BodySmall>
                    </Flex>
                    <Flex gap={Spacing._4} alignItems="center">
                        <GTButton
                            value="Re-block"
                            styleType="secondary"
                            onClick={reblock}
                            disabled={isConfirming || hasPendingConfirmation || isLoading}
                        />
                        <GTButton
                            value="Clear"
                            styleType="secondary"
                            onClick={clear}
                            disabled={isConfirming || isClearing}
                        />
                        <GTButton
                            value={
                                hasPendingConfirmation
                                    ? 'Finish adding blocks'
                                    : `Add ${plan?.actions.length ?? 0} block${plan?.actions.length === 1 ? '' : 's'}`
                            }
                            styleType="primary"
                            onClick={confirm}
                            disabled={isConfirming || !plan || plan.actions.length === 0}
                        />
                    </Flex>
                </Flex>
                {confirmationError && <BodySmall color="red">{confirmationError}</BodySmall>}
                {plan && plan.unscheduled.length > 0 && (
                    <details data-testid="calendar-plan-unscheduled">
                        <summary>Didn’t fit · {plan.unscheduled.length}</summary>
                        {plan.unscheduled.map((task) => (
                            <BodySmall key={task.task_id}>
                                {task.title} · {task.reasons.join(' · ')}
                            </BodySmall>
                        ))}
                    </details>
                )}
            </Flex>
        </Review>
    )
}

export default CalendarPlanReview
